
import { DashboardMenu } from "../../data/menu"
import DashboardButton from "../Setting/dashboardButton";
import BreadCrump from "../tools/breadcrump"
import { useTranslation } from 'react-i18next';


export default function IndexGallery() {
    const { t } = useTranslation();

    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Setting',
            url: null
        },
    ]
    return (
        <>
            <div className="text-left  bg-white  p-3 m-4 directions   h-[100vh] mb-5 ">
                <BreadCrump data={breadcrump}></BreadCrump>
                <DashboardButton item="Gallery" DashboardMenu={DashboardMenu}></DashboardButton>

               
            </div>

        </>
    )
}